<template>
</template>

<script>

export default {
  name: "Session"
}


</script>

<style scoped>
.headerFont {
	font-family:Verdana, Arial, Helvetica, sans-serif;
	font-size:11px;
	color:#990000;
}
.regularFont {
	font-family:Verdana, Arial, Helvetica, sans-serif;
	font-size:10px;
}
.regularButton {
	 width:200px;
	 background-color:#00CC33;
	 font-family:Verdana, Arial, Helvetica, sans-serif;
	 color:#FFFFFF;
	 font-size:12px;
	 font-weight:bold;
	 border-color:#009900;
	 border-width:1;
	 border-style:solid;
	 height:35px;
}
</style>